import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <header className="header">
      <nav className="nav-bar">
        <h1 className="logo">ERP Watcher</h1>

        {/* bouton burger visible en mobile */}
        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label="Ouvrir le menu"
        >
          ☰
        </button>

        <div className={`nav-links ${isOpen ? 'nav-open' : ''}`}>
          <Link
            to="/dashboard"
            className={location.pathname === '/dashboard' ? 'active-link' : ''}
            onClick={() => setIsOpen(false)}
          >
            Accueil
          </Link>
          <Link
            to="/applications"
            className={location.pathname === '/applications' ? 'active-link' : ''}
            onClick={() => setIsOpen(false)}
          >
            Applications
          </Link>
          <Link
            to="/natures"
            className={location.pathname === '/natures' ? 'active-link' : ''}
            onClick={() => setIsOpen(false)}
          >
            Natures
          </Link>
          <Link
            to="/taux-dispo"
            className={location.pathname === '/taux-dispo' ? 'active-link' : ''}
            onClick={() => setIsOpen(false)}
          >
            Taux de disponibilité
          </Link>
          <button onClick={handleLogout}>Déconnexion</button>
        </div>
      </nav>
    </header>
  );
}
